import {
  DndContext,
  DndContextProps,
  DragEndEvent,
  DragOverEvent,
  MouseSensor,
  TouchSensor,
  closestCenter,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import React from "react";

type DndContextComponentProps = {
  onDragEnd?: (event: DragEndEvent) => void;
  onDragOver?: (event: DragOverEvent) => void;
  children: React.ReactNode;
} & DndContextProps;

export const DNDContext: React.FC<DndContextComponentProps> = ({
  onDragEnd,
  onDragOver,
  children,
  ...props
}) => {
  // MouseSensor (mouse only) rather than PointerSensor: PointerSensor also fires
  // for touch, and with no delay it would race the TouchSensor and grab a scroll
  // gesture as a drag on touchscreens. Mouse drags immediately, touch needs a
  // 200ms press.
  const sensors = useSensors(
    useSensor(MouseSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 200,
        tolerance: 6,
      },
    }),
  );

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={onDragEnd}
      onDragOver={onDragOver}
      {...props}
    >
      {children}
    </DndContext>
  );
};
